import { Branch } from "./branch";

export class Customer {
    id: string;
    name: string;
    prefix: string;
    roc_number: string;
    fiscal_id: string;
    address: string;
    city_id: number;
    city_name: string;
    country_id: number;
    country_name: string;
    contact_name: number;
    mobile_number: number;
    phone_number: string;
    fax_number: number;
    email_address: string;
    term_of_payment: string;
    credit_margin: { margin: string, date: string }[] = [];
    credit_date: string = (new Date()).toISOString().substr(0, 10);
    sales_person: string;
    notes: string;
    shipping_address: string;
    shipping_city_id: number;
    shipping_city_name: string;
    shipping_country_id: number;
    shipping_country_name: string;
    bank: string;
    account: string;
    share_capital: string;
    
    branches: Branch[] = [];
    branch: string;
}


// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/accounting/customer.ts